// فرصت‌های شغلی — در حال حاضر موقعیت شغلی فعالی وجود ندارد.
// به محض نیاز به نیرو، فرصت‌های شغلی به همین آرایه اضافه می‌شوند تا در صفحه «همکاری با ما» نمایش داده شوند.
// نمونه ساختار هر آیتم:
// { id: 1, title: "راننده پیک موتوری", department: "عملیات و حمل", location: "کرمان", type: "تمام‌وقت" }
export interface Position { id: number; title: string; department: string; location: string; type: string }

export const openPositions: Position[] = []
